import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { PageTitle, Panel, Field, TextArea, TextInput, Btn, StatCard } from "../components/ui";
import { useI18n } from "../i18n";
import { CL } from "../api";

// IFRS S1 — General Sustainability-related Financial Disclosures (ISSB)
// Four core pillars: Governance, Strategy, Risk Management, Metrics & Targets.
export default function IfrsS1() {
  const { t } = useI18n();
  const [d, setD] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => { CL.getIfrsS1().then(setD).catch(() => {}); }, []);
  if (!d) return null;
  const a = d.auto || {};
  const up = (k) => (e) => { const v = e.target.value; setD((p) => ({ ...p, [k]: v })); };

  const save = async () => {
    setSaving(true);
    try {
      await CL.putIfrsS1({
        governance: d.governance || "",
        strategy: d.strategy || "",
        risk_management: d.risk_management || "",
        metrics_targets: d.metrics_targets || "",
        material_topics: d.material_topics || "",
        reporting_period: d.reporting_period || "",
      });
      toast.success(t("saved"));
    } catch { toast.error("Error"); } finally { setSaving(false); }
  };

  return (
    <div data-testid="ifrs-s1-page">
      <PageTitle title={t("ifrsS1Title")} subtitle={t("ifrsS1Desc")} />

      <div className="mb-6 grid grid-cols-1 gap-4 md:grid-cols-3">
        <StatCard testId="s1-entity" label={t("entity")} value={a.entity_name || "—"} />
        <StatCard testId="s1-year" label={t("reportingYear")} value={a.reporting_year || "—"} accent="#2f8f5b" />
        <StatCard testId="s1-total" label={t("totalEmissions")} value={(a.total_t ?? 0).toLocaleString()} sub={t("tCO2e")} accent="#e08a1e" />
      </div>

      <Panel className="max-w-3xl">
        <div className="mb-4 font-display text-lg text-[#14512f]">{t("ifrsS1PillarsTitle")}</div>

        <Field label={t("ifrsGovernance")}>
          <TextArea data-testid="s1-governance" value={d.governance || ""} onChange={up("governance")} />
        </Field>
        <div className="mt-4">
          <Field label={t("ifrsStrategy")}>
            <TextArea data-testid="s1-strategy" value={d.strategy || ""} onChange={up("strategy")} />
          </Field>
        </div>
        <div className="mt-4">
          <Field label={t("ifrsRiskMgmt")}>
            <TextArea data-testid="s1-risk" value={d.risk_management || ""} onChange={up("risk_management")} />
          </Field>
        </div>
        <div className="mt-4">
          <Field label={t("ifrsMetricsTargets")}>
            <TextArea data-testid="s1-metrics" value={d.metrics_targets || ""} onChange={up("metrics_targets")} />
          </Field>
        </div>
        <div className="mt-4 grid grid-cols-2 gap-4">
          <Field label={t("materialTopics")}>
            <TextInput data-testid="s1-material" value={d.material_topics || ""} onChange={up("material_topics")} />
          </Field>
          <Field label={t("reportingPeriod")}>
            <TextInput data-testid="s1-period" value={d.reporting_period || ""} onChange={up("reporting_period")} placeholder="2025" />
          </Field>
        </div>

        <div className="mt-6">
          <Btn onClick={save} disabled={saving} data-testid="s1-save">
            {saving ? "..." : t("save")}
          </Btn>
        </div>
      </Panel>
    </div>
  );
}
